import { render } from "./MifidQuestionnaire.vue?vue&type=template&id=3850be5f"
import script from "./MifidQuestionnaire.vue?vue&type=script&lang=js"
export * from "./MifidQuestionnaire.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__